import * as React from 'react';
import { dinogo, tripi, vnpay } from '../../../../../assets/index';
import './MobilePartner.scss';
const menu = [
  {
    id: 0,
    logo: tripi,
  },
  {
    id: 1,
    logo: dinogo,
  },
  {
    id: 2,
    logo: vnpay,
  },
];
const MobilePartner = (props) => {
  return (
    <div className='mobile-partner'>
      <div className='partner_home-mobile'>
        <div className='title'>Đối tác</div>

        <div className='wrapListItem'>
          <div className='listItem'>
            {menu.map((el, index) => (
              <div className='pict-partner' key={index}>
                <img src={el.logo} alt='' />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobilePartner;
